const INITIAL_FILTER = {
    name: "",
    nickname: "",
    cpf: "",
    rg: "",
    cnh: "",
    socialName: "",
    sex: "",
    maritalStatus: "",
    nationality: "",
    cityOfBirth: "",
    mother: "",
    father: "",
    height_max: "",
    height_min: "",
    color: "",
    bodyShape: "",
    eyes: "",
    hairType: "",
    hairColor: "",
    local: "",
    type: "",
    description: "",
    isHomeless: "",
    address: "",
    neighborhood: "",
    city: "",
    complement: "",
    zipCode: "",
    roleCrime: "",
    situation: "",
    socialNetwork: "",
    educationDegree: "",
    occupation: "",
    information: "",
    article: "",
    individualReferral: "",
    dtBirth_max: "",
    dtBirth_min: "",
    phone: "",
    alcoholDrugDependency: false,
    mentalDisorder: false,
    imageMode: false,
    photoFace: false,
    phoneticSearch: false,
    associations: []
}

export default INITIAL_FILTER;
